import {BaseService} from '../baseService.js';

export class MigrationService extends BaseService {

	async getMigrations(paging) {
		var params = paging ? '?' + this.toQueryParam(paging) : '';
		return this.makeGETRequest('/api/resource/migrations' + params);
	}

	exportMigrations(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/migrations/export' + params);
	}

	async getMigration(migrationId) {
		return this.makeGETRequest('/api/resource/migrations/' + migrationId);
	}

	async getMigrationMessages(migrationId, paging) {
		var params = paging ? '?' + this.toQueryParam(paging) : '';
		return this.makeGETRequest('/api/resource/migrations/' + migrationId + '/messages' + params);
	}

	async getMigrationErrors(migrationId) {
		return this.makeGETRequest('/api/resource/migrations/' + migrationId + '/errors');
	}

	downloadMigrationMessages(migrationId) {
		this.downloadFile('/api/resource/migrations/' + migrationId + '/messages/export');
	}

	async getMigrationUsers(migrationId) {
		return this.makeGETRequest('/api/resource/migrations/' + migrationId + '/users');
	}

	async getMigrationGroups(migrationId) {
		return this.makeGETRequest('/api/resource/migrations/' + migrationId + '/groups');
	}

	async getV6Candidates() {
		return this.makeGETRequest('/api/resource/migrations/v6-candidates');
	}

	async searchV6Companies(searchParams) {
		var params = searchParams ? '?' + this.toQueryParam(searchParams) : '';
		return this.makeGETRequest('/api/resource/migrations/companies' + params);
	}

	async getV6BillingAccount(v6CompanyId) {
		return this.makeGETRequest('/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount');
	}

	async getV6BillingAccountPreferences(v6CompanyId, accountNo) {
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/preferences'
		);
	}

	async getV6BillingAccountComments(v6CompanyId, accountNo) {
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/comments'
		);
	}

	async getV6BillingAccountStatuses(v6CompanyId, accountNo) {
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/statuses'
		);
	}

	async getV6BillingAccountBalances(v6CompanyId, accountNo, dateRange) {
		var params = dateRange ? '?' + this.toQueryParam(dateRange) : '';
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/balances' + params
		);
	}

	async getV6BillingAccountOrders(v6CompanyId, accountNo) {
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/orders'
		);
	}

	async getV6BillingAccountInvoices(v6CompanyId, accountNo, dateRange) {
		var params = dateRange ? '?' + this.toQueryParam(dateRange) : '';
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/invoices' + params
		);
	}

	async getV6BillingAccountInvoice(v6CompanyId, accountNo, invoiceNo) {
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/invoices/' + invoiceNo
		);
	}

	async getV6BillingAccountPayments(v6CompanyId, accountNo, dateRange) {
		var params = dateRange ? '?' + this.toQueryParam(dateRange) : '';
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/payments' + params
		);
	}

	async getV6BillingAccountAdjustments(v6CompanyId, accountNo) {
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/adjustments'
		);
	}

	async getV6BillingAccountFactorSetups(v6CompanyId, accountNo) {
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/factor-setups'
		);
	}

	async getV6BillingAccountFactorAudits(v6CompanyId, accountNo) {
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/factor-audits'
		);
	}

	async getV6BillingAccountFactorAuditDetails(v6CompanyId, accountNo, accountFactorId, paging) {
		var params = paging ? '?' + this.toQueryParam(paging) : '';
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo
				+ '/factor-audits/' + accountFactorId + '/details' + params
		);
	}

	async getV6BillingAccountPaymentMethods(v6CompanyId, accountNo) {
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/payment-methods'
		);
	}

	async getV6BillingAccountProductTransactions(v6CompanyId, accountNo, dateRange) {
		var params = dateRange ? '?' + this.toQueryParam(dateRange) : '';
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/product-transactions' + params
		);
	}

	async getV6BillingAccountReferralDetails(v6CompanyId, accountNo) {
		return this.makeGETRequest(
			'/api/resource/migrations/companies/' + v6CompanyId + '/billingaccount/' + accountNo + '/referral-details'
		);
	}

	async getV6AccountCompanyMap() {
		return this.makeGETRequest('/api/resource/migrations/billing/account-company-map');
	}

	async createMigration(migrationRequest) {
		return this.makePOSTRequest('/api/resource/migrations', migrationRequest);
	}

	async updateMigration(migrationId, updateRequest) {
		return this.makePUTRequest('/api/resource/migrations/' + migrationId, updateRequest);
	}

	async getSyncHistory(migrationId) {
		return this.makeGETRequest('/api/resource/migrations/' + migrationId + '/sync-history');
	}

	async getMigrationStepOptions() {
		return this.makeGETRequest('/api/resource/migrations/step-options');
	}

	async resyncMigration(migrationId, resyncRequest) {
		return this.makePOSTRequest('/api/resource/migrations/' + migrationId + '/resync', resyncRequest);
	}

	async saveValidationChecklist(migrationId, checklistRequest) {
		return this.makePUTRequest(
			'/api/resource/migrations/' + migrationId + '/validation-checklist',
			checklistRequest || {}
		);
	}

	async markValidationComplete(migrationId, checklistRequest) {
		return this.makePOSTRequest(
			'/api/resource/migrations/' + migrationId + '/validation-complete',
			checklistRequest || {}
		);
	}

	async finalizeMigration(migrationId, finalizeRequest) {
		return this.makePOSTRequest('/api/resource/migrations/' + migrationId + '/finalize', finalizeRequest);
	}

	async getFinalizePreview(migrationId) {
		return this.makeGETRequest('/api/resource/migrations/' + migrationId + '/finalize-preview');
	}

	async markCutoverComplete(migrationId) {
		return this.makePOSTRequest('/api/resource/migrations/' + migrationId + '/cutover', {});
	}

	async retryMigration(migrationId, retryRequest) {
		return this.makePOSTRequest('/api/resource/migrations/' + migrationId + '/retry', retryRequest || {});
	}

	async suspendMigration(migrationId) {
		return this.makePUTRequest('/api/resource/migrations/' + migrationId + '/suspend', {});
	}

	async resumeMigration(migrationId) {
		return this.makePUTRequest('/api/resource/migrations/' + migrationId + '/resume', {});
	}

	async cancelMigration(migrationId) {
		return this.makePUTRequest('/api/resource/migrations/' + migrationId + '/cancel', {});
	}
}
